import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import questionaryDataccess from "src/dataAccess/questionaries/questionaryDataccess";

export const getQuestionaryListSuccess = createAction<any>(
  "[Questionary] Get Questionary List Success"
);
export const loadingList = createAction<boolean>("[Questionary] Loading list");
export const setProcedureId = createAction<any>(
  "[Questionary] Set ProcedureId"
);
export const getQuestionaryListAsync = createAsyncThunk<any, IListType>(
  "[Questionary] Get Questionary List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await questionaryDataccess.getList(parameter).then((res) => {
      thunkAPI.dispatch(getQuestionaryListSuccess(res));
      thunkAPI.dispatch(loadingList(false));
      return res;
    });
    return result;
  }
);

export const RemoveCompletedQuestionnaire = createAction<any>(
  "Remove Completed Questionnaire"
);
export const SetCompletedQuestionnaire = createAction<any[]>(
  "[NC] set Completed Questionnaire"
);

export const getOverdueQuestionnaireListAsyncSuccess = createAction<any>(
  "[Site] Get Overdue Audit List Success"
);

export const getOverdueQuestionnaireListAsync = createAsyncThunk<
  any,
  IListType
>(
  "[Questionnaire] Get Overdue Questionnaire List",
  async (parameter, thunkAPI) => {
    console.log(parameter);
    thunkAPI.dispatch(loadingList(true));
    const result = await questionaryDataccess
      .getOverdueQuestionnaireListAsync(parameter)
      .then((res) => {
        thunkAPI.dispatch(getOverdueQuestionnaireListAsyncSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);
